var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    role: "img",
    "aria-label": "Y Combinator",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 28,
    fill: "#FB651E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.7 168.2v-32.1L83 67h22.4l20.1 41c2.3 4.7 4.3 9 6.2 13.7 1.9-4.5 4-9 6.3-13.6L158.4 67H179l-37 69.4v31.8z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYc);
export default __webpack_public_path__ + "static/media/yc.40c19be4a8d03f5bab33d73af2da5c71.svg";
export { ForwardRef as ReactComponent };